import {DatesProvider} from '@mantine/dates'
import {DayItemsProvider} from '../../providers/dayItems/DayItemsProvider.tsx'
import {CalendarContainer} from './CalendarContainer.tsx'
import {FiltersProvider} from './providers/filters/FiltersProvider.tsx'

export const CalendarScreen = () => {
  return (
    <DatesProvider settings={{consistentWeeks: false}}>
      <FiltersProvider>
        <DayItemsProvider>
          <CalendarContainer />
        </DayItemsProvider>
      </FiltersProvider>
    </DatesProvider>
  )
}
